// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Aa66t","loading":"Home_loading__gBOkt","spinner":"Home_spinner__jUoZ9","spin":"Home_spin__CaJH7"};